
import type { PropOptions } from 'vue';
import Vue from 'vue';
import MoreIcon from '@/assets/svg/more.vue.svg';
import Dropdown from '~/components/common/Dropdown/Dropdown.vue';
import DropdownMenu from '~/components/common/Dropdown/DropdownMenu.vue';
import DropdownItem from '~/components/common/Dropdown/DropdownItem.vue';

export default Vue.extend({
  name: 'ArchivedTestimonial',
  components: { MoreIcon, Dropdown, DropdownMenu, DropdownItem },
  props: {
    avatar: {
      type: String,
      default: '',
    } as PropOptions<string>,
    authorName: {
      type: String,
      default: '',
    } as PropOptions<string>,
    authorPosition: {
      type: String,
      default: '',
    } as PropOptions<string>,
    testimonial: {
      type: String,
      default: '',
    } as PropOptions<string>,
    testimonialId: {
      type: String,
      default: '',
    } as PropOptions<string>,
  },
});
